import React, { useState } from 'react'
import { Link } from 'gatsby'
import { useTranslate } from '@chordcommerce/gatsby-theme-autonomy'
import { redeemGift } from '~/utils/redeem-gift'
import { toURL } from '~/utils/intl/localePrefix'
import Text from '~/components/IntlComponents/Text'

const useRedeemGift = slug => {
  const translate = useTranslate()
  const [formSubmitting, setFormSubmitting] = useState(false)
  const [submitError, setSubmitError] = useState(null)

  const submitGiftForm = async ({ email, sku, ...formData }) => {
    setFormSubmitting(true)

    const { subscribed, ...rest } = formData

    const requestGiftObject = {
      slug: slug,
      subscribe: subscribed,
      order_attrs: {
        email,
        bill_address_attributes: rest,
        ship_address_attributes: rest,
        line_items_attributes: [{ quantity: 1, sku }],
      },
    }

    const { complete_response } = await redeemGift(requestGiftObject)

    if (!complete_response?.number) {
      setSubmitError(
        translate('gifting_flow.submission_failed_error', {
          contact_link: (
            <Link to={toURL('/contact')}>
              <Text sx={{ textDecoration: 'underline' }}>
                {translate('gifting_flow.contact_us')}
              </Text>
            </Link>
          ),
        }),
      )

      return setFormSubmitting(false)
    }

    return complete_response
  }

  return [formSubmitting, submitGiftForm, submitError]
}

export default useRedeemGift
